/**
 * BFF 网络埋点（仅由 http-interceptor 调用）。
 */

import { track } from './track'

export const API_EVENTS = {
  api_request: 'api_request',
  api_response: 'api_response'
} as const

export type ApiRequestAnalyticsCtx = {
  api_path: string
  trace_id: string
  request_id: string
  start_ts: number
}

export function trackApiRequest(props: {
  api_path: string
  trace_id: string
  request_id: string
}): void {
  track(API_EVENTS.api_request, {
    api_path: props.api_path,
    trace_id: props.trace_id,
    request_id: props.request_id
  })
}

export function trackApiResponse(props: {
  trace_id: string
  request_id?: string
  api_path?: string
  http_code: number | string
  biz_code: number | string
  duration_ms: number
}): void {
  const payload: Record<string, unknown> = {
    trace_id: props.trace_id,
    http_code: props.http_code,
    biz_code: props.biz_code,
    duration_ms: Math.max(0, Math.round(props.duration_ms))
  }
  if (props.request_id) payload.request_id = props.request_id
  if (props.api_path) payload.api_path = props.api_path
  track(API_EVENTS.api_response, payload)
}
